module.exports = __webpack_public_path__ + "static/text@1.5x-3fe9776b799cf6614e11a805f47fc9c1.png";